import React from 'react'
import PropTypes from 'prop-types'

import cn from '../../libs/class-name'

const Container = ({
  classNames,
  children,
  backArrow,
  prevArrow,
  nextArrow
}) => (
  <div className={cn('Container', {}, classNames)}>
    {backArrow && <div className="Container__backArrow">{backArrow}</div>}
    {children}
    {(prevArrow || nextArrow) && (
      <div className="Container__arrows">
        <div className="Container__prevArrow">{prevArrow}</div>
        <div className="Container__nextArrow">{nextArrow}</div>
      </div>
    )}
  </div>
)

Container.propTypes = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
  backArrow: PropTypes.node,
  prevArrow: PropTypes.node,
  nextArrow: PropTypes.node
}

export default Container
